import React, { useState, useEffect } from 'react';
import { useLanguage } from './../../store/languageContext';
import { LanguageFactory, LocalPersistence } from './../../factories';
import { Tabs, Form, message } from 'antd';
import AttractionDetailAdd from './Detail/Views/AttractionDetailAdd';
import AttractionDetailEdit from './Detail/Views/AttractionDetailEdit';
import AttractionDetailView from './Detail/Views/AttractionDetailView';
import AttractionLocationAdd from './Location/Views/AttractionLocationAdd';
import AttractionLocationView from './Location/Views/AttractionLocationView';
import AttractionLocationEdit from './Location/Views/AttractionLocationEdit';
import { addAttraction } from '../../services/attraction';
import styles from './index.module.css'
import moment from 'moment';
import Loading from '../Loading';
import ActionButtonsBar from '../ui/ActionButtonsBar';
const { TabPane } = Tabs;
const dateFormat = 'MM/DD/YYYY';
const AttractionTabs = (props: { isEditable:any, cancelEditable:any, currentFlag:any,currentLine:any, setCurrentFlag: any,setTransferData:any,typeAccData:any,typeLayData:any,transferData:any,stateData:any,setCurrentLine:any }) => {
    const [form] = Form.useForm()
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([])
    const [addAndViewActiveTab, setAddAndViewActiveTab] = useState('1')
    const [addLoading, setAddLoading] = useState<boolean>(false)
    const [disabledStatus, setDisabledStatus] = useState(true)
    const [typeData, setTypeData] = useState<Array<any>>([])
   

    const dataListTab = props.currentLine && props.currentLine.locations && props.currentLine.locations.length > 0 ? props.currentLine.locations: [];
    const [locationData, setLocationData] = useState<object[]>(dataListTab);

    const changeTab = (key:string)=>{
        setAddAndViewActiveTab(key)
    }

    useEffect(() => {
        props.currentFlag=='edit' || props.currentFlag=='add'? props.isEditable(true) : props.cancelEditable(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentFlag])

    const SaveClick = () => {
        (async () => {           
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence()
            form.validateFields().then( async(value) => {
                setAddLoading(true)
                value.tags = transferTargetKeys.length!=0?transferTargetKeys.join(' | ') : ''
                value.startdate = value.startAndEndDate && value.startAndEndDate.length > 0 ? moment(value.startAndEndDate[0]).format(dateFormat) : ''
                value.enddate = value.startAndEndDate && value.startAndEndDate.length > 0 ? moment(value.startAndEndDate[1]).format(dateFormat) : ''
                let locationArr: any = []
                for (let key in value.locations) {
                    locationArr.push(value.locations[key])
                }
                value.locations = locationArr
                const bodyQuery:any = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        attractions: [value]
                    } 
                }
               await addAttraction(bodyQuery).then(res => {
                    if (res.result.success) {
                        setAddLoading(false)
                    props.setCurrentFlag('table')
                    } else {
                        setAddLoading(false)
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }
                }, err => {
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                    setAddLoading(false)
                })
                
            }).catch(() => {
                setAddLoading(false)
                message.error({
                    content: 'Check all the fields please.',
                });
            })
        })()
    }
    const changeTypeData = (value: any)=> {
        form.setFields([{
            name: 'type',
            value: ''
          }])
        if (value === 'Open Travel Standard') {
            setTypeData(props.typeAccData)
        } else if (value === 'Lanyon Attraction Type') {
            setTypeData(props.typeLayData)
        }
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
          setDisabledStatus(false)
    
        }).catch(() => {
                let savelock = false
                let s = form?.getFieldsError()
                    for (let i = 0; i < s.length; i++) {
                    if(s[i].errors.length) {
                        savelock = true;
                        break
                    }
                }
                setDisabledStatus(savelock)
        })
      }

    if (addLoading) return <Loading type={'large'} />
    switch (props.currentFlag) {
        case 'add':
            return (
              <div className={styles.addCon}>
                <Form
                  layout='vertical'
                  form={form}
                  className={styles.addForm}
                  onValuesChange={validateFieldsError}
                  name='basic'>
                  <Tabs
                    defaultActiveKey={addAndViewActiveTab}
                    onChange={changeTab}>
                    <TabPane
                      tab={lang.translate(language, 'attractions_tab1')}
                      key='1'
                      disabled={props.currentFlag == 'edit'}
                      forceRender={true}>
                      <AttractionDetailAdd
                        typeData={typeData}
                        changeTypeData={changeTypeData}
                        transferTargetKeys={transferTargetKeys}
                        setTransferTargetKeys={setTransferTargetKeys}
                        setTransferData={props.setTransferData}
                        transferData={props.transferData}
                        typeLayData={props.typeLayData}
                        typeAccData={props.typeAccData}
                        setCurrentFlag={props.setCurrentFlag}
                        currentFlag={props.currentFlag}
                      />
                    </TabPane>
                    <TabPane
                      tab={lang.translate(language, 'attractions_tab2')}
                      key='2'
                      disabled={props.currentFlag == 'edit'}
                      forceRender={true}>
                      <AttractionLocationAdd
                        form={form}
                        validateFieldsError={validateFieldsError}
                        stateData={props.stateData}
                        setCurrentFlag={props.setCurrentFlag}
                      />
                    </TabPane>
                  </Tabs>
                </Form>
                <ActionButtonsBar
                  onCancel={() => props.setCurrentFlag('table')}
                  onSave={SaveClick}
                  disabledSave={disabledStatus}
                />
              </div>
            )
        case 'edit':
            return (
              <Tabs defaultActiveKey={addAndViewActiveTab} onChange={changeTab}>
                <TabPane
                  tab={lang.translate(language, 'attractions_tab1')}
                  key='1'
                  disabled={props.currentFlag == 'edit'}
                  forceRender={true}>
                  {props.currentFlag == 'edit' && (
                    <AttractionDetailEdit
                      setTransferData={props.setTransferData}
                      transferData={props.transferData}
                      typeLayData={props.typeLayData}
                      typeAccData={props.typeAccData}
                      setCurrentFlag={props.setCurrentFlag}
                      currentFlag={props.currentFlag}
                      currentLine={props.currentLine}
                      setCurrentLine={props.setCurrentLine}
                    />
                  )}
                </TabPane>

                <TabPane
                  tab={lang.translate(language, 'attractions_tab2')}
                  key='2'
                  disabled={props.currentFlag == 'edit'}
                  forceRender={true}>
                  {props.currentFlag == 'edit' && (
                    <AttractionLocationEdit
                      stateData={props.stateData}
                      setCurrentFlag={props.setCurrentFlag}
                      setLocationData={setLocationData}
                      currentLine={props.currentLine}
                      locationData={locationData}
                    />
                  )}
                </TabPane>
              </Tabs>
            )
        default:
            return (
              <Tabs defaultActiveKey={addAndViewActiveTab} onChange={changeTab}>
                <TabPane
                  tab={lang.translate(language, 'attractions_tab1')}
                  key='1'
                  disabled={props.currentFlag === 'edit'}
                  forceRender={true}>
                  {props.currentFlag === 'view' && (
                    <AttractionDetailView
                      setCurrentFlag={props.setCurrentFlag}
                      currentLine={props.currentLine}
                    />
                  )}
                </TabPane>
                <TabPane
                  tab={lang.translate(language, 'attractions_tab2')}
                  key='2'
                  disabled={props.currentFlag === 'edit'}
                  forceRender={true}>
                  {props.currentFlag === 'view' && (
                    <AttractionLocationView
                      currentLine={props.currentLine}
                      setCurrentFlag={props.setCurrentFlag}
                      locationData={locationData}
                    />
                  )}
                </TabPane>
              </Tabs>
            )
    }
}

export default AttractionTabs;

